gz-title + gz-form-field {
  padding-top: 15px;
}

.module-subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

gz-checkbox {
  width: auto;
}
